<template>
	<svg
		width="14"
		height="15"
		:class="classes"
		viewBox="0 0 14 15"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clip-path="url(#clip0_4771_31899)">
			<mask
				id="mask0_4771_31899"
				style="mask-type:luminance"
				maskUnits="userSpaceOnUse"
				x="0"
				y="0"
				width="14"
				height="15"
			>
				<path
					d="M11.375 6.93066H2.62502C2.30285 6.93066 2.04169 7.19183 2.04169 7.514V12.764C2.04169 13.0862 2.30285 13.3473 2.62502 13.3473H11.375C11.6972 13.3473 11.9584 13.0862 11.9584 12.764V7.514C11.9584 7.19183 11.6972 6.93066 11.375 6.93066Z"
					fill="white"
					stroke="white"
					stroke-width="2.33333"
					stroke-linejoin="round"
				/>
				<path
					d="M4.08338 6.91655V4.58468C4.08192 3.08697 5.22758 1.83193 6.73346 1.68143C8.23933 1.53093 9.61542 2.53397 9.91671 4.00164"
					stroke="white"
					stroke-width="2.33333"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
				<path
					d="M7 9.25V11"
					stroke="black"
					stroke-width="2.33333"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
			</mask>
			<g mask="url(#mask0_4771_31899)">
				<path
					d="M0 0.5H14V14.5H0V0.5Z"
					:fill="color"
				/>
			</g>
		</g>
		<defs>
			<clipPath id="clip0_4771_31899">
				<rect
					width="14"
					height="14"
					fill="white"
					transform="translate(0 0.5)"
				/>
			</clipPath>
		</defs>
	</svg>
</template>

<script setup>
const props = defineProps({
	color: {
		type: String,
		default: '#2A8176'
	},
	classes: {
		type: String,
		default: ''
	}
});
</script>